module.exports = __webpack_public_path__ + "img/2019-seattle.3ea05437.jpg";